import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Track } from '../../api/lib/api/tracks';

import { ProfileLink } from '../common/Link';

const TrackArtist = ({
  track,
  className,
}: {
  track?: Track;
  className?: string;
}) => {
  if (!track) {
    return null;
  }

  const { collaborators, user } = track;

  if (collaborators.length === 0) {
    return (
      <ProfileLink className={className} profileId={user.id}>
        {user.display_name}
      </ProfileLink>
    );
  }

  if (collaborators.length > 0) {
    return (
      <>
        <ProfileLink className={className} profileId={user.id}>
          {user.display_name}
        </ProfileLink>
        {collaborators.map((c) => (
          <Fragment key={c.id}>
            {', '}
            <ProfileLink className={className} profileId={c.id}>
              {c.display_name}
            </ProfileLink>
          </Fragment>
        ))}
      </>
    );
  }

  return null;
};

export default styled(TrackArtist)``;
